var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C18.8513 24 24 18.8513 24 12.5C24 6.14873 18.8513 1 12.5 1C6.14873 1 1 6.14873 1 12.5C1 18.8513 6.14873 24 12.5 24Z",
    stroke: "#D9D9D9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1357 16.502C10.9459 16.5025 10.763 16.431 10.6238 16.302L7.14185 13.05C7.06963 12.9828 7.01125 12.9021 6.97022 12.8124C6.9292 12.7227 6.90641 12.6258 6.90284 12.5272C6.89926 12.4286 6.91505 12.3303 6.94947 12.2379C6.98389 12.1455 7.03611 12.0607 7.10328 11.9884C7.17045 11.9162 7.25113 11.858 7.34083 11.8169C7.43053 11.7759 7.52741 11.7529 7.62598 11.7494C7.72455 11.7458 7.8231 11.7617 7.91553 11.7961C8.00797 11.8305 8.09258 11.8828 8.1648 11.95L11.0938 14.685L16.7468 8.51395C16.8128 8.43948 16.893 8.37891 16.9827 8.33573C17.0723 8.29256 17.1697 8.26766 17.2691 8.26249C17.3684 8.25732 17.4679 8.27195 17.5615 8.30558C17.6552 8.33922 17.7413 8.3912 17.8147 8.45841C17.8881 8.52563 17.9473 8.60677 17.989 8.69712C18.0307 8.78748 18.0541 8.8852 18.0576 8.98466C18.0612 9.08411 18.0449 9.1833 18.0098 9.27641C17.9746 9.36951 17.9212 9.45467 17.8528 9.52695L11.6887 16.257C11.6216 16.3299 11.5409 16.3887 11.4509 16.4302C11.361 16.4717 11.2638 16.4951 11.1648 16.4989L11.1357 16.502Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledCheckCircle);
export default __webpack_public_path__ + "static/media/disabledCheckCircle.5f502166816637af9a8706db0d2d965b.svg";
export { ForwardRef as ReactComponent };